var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import MuiTooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import MuiHelpOutlineIcon from '@mui/icons-material/HelpOutline';
var IconTooltip = forwardRef(function (_a, ref) {
    var iconComponent = _a.iconComponent, _b = _a.iconColor, iconColor = _b === void 0 ? 'inherit' : _b, iconSize = _a.iconSize, iconSX = _a.iconSX, _c = _a.placement, placement = _c === void 0 ? 'top' : _c, otherProps = __rest(_a, ["iconComponent", "iconColor", "iconSize", "iconSX", "placement"]);
    var tooltipProps = __assign(__assign({ enterDelay: 500, placement: placement }, otherProps), { arrow: true, ref: ref });
    var Icon = iconComponent || MuiHelpOutlineIcon;
    var fontSize = iconSize || 'small';
    var sxColor = iconColor === 'inherit' ? 'inherit' : undefined;
    return (_jsx(MuiTooltip, __assign({}, tooltipProps, { children: _jsx(IconButton, __assign({ sx: { color: sxColor, padding: 0, marginLeft: 0.5, height: 'max-content' } }, { children: _jsx(Icon, { color: iconColor, sx: __assign({ color: sxColor, fontSize: fontSize }, iconSX) }) })) })));
});
export default IconTooltip;
